import type { IdentityDocumentValidationCountry } from '../market/resolveIdentityDocumentValidationCountry';

import { normalizeIdentityDocumentNumber } from './identityDocumentFingerprint';

const identityDocumentRegistryPublicUrls = {
  SK: 'https://www.minv.sk/?stratene-a-odcudzene-doklady',
  CZ: 'https://mv.gov.cz/neplatne-doklady/',
} satisfies Record<IdentityDocumentValidationCountry, string>;

const czechDocumentTypeIds = {
  PERSONAL_ID: '1',
  PASSPORT: '2',
} as const;

export function getIdentityDocumentRegistryPublicUrl(
  country: IdentityDocumentValidationCountry,
  context?: {
    identification: string;
    identificationNumber: string;
  },
): string {
  const baseUrl = identityDocumentRegistryPublicUrls[country];
  if (country !== 'CZ' || !context) {
    return baseUrl;
  }

  const documentTypeId =
    context.identification === 'PASSPORT'
      ? czechDocumentTypeIds.PASSPORT
      : context.identification === 'PERSONAL_ID'
        ? czechDocumentTypeIds.PERSONAL_ID
        : undefined;
  const documentId = normalizeIdentityDocumentNumber(context.identificationNumber);
  if (!documentTypeId || !documentId) {
    return baseUrl;
  }

  const query = new URLSearchParams({
    DocumentId: documentId,
    DocumentTypeId: documentTypeId,
  });
  return `${baseUrl}?${query.toString()}`;
}
